import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=21a241b0"
import script from "./EditIcon.vue?vue&type=script&lang=ts"
export * from "./EditIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a241b0')) {
      api.createRecord('21a241b0', component.options)
    } else {
      api.reload('21a241b0', component.options)
    }
    module.hot.accept("./EditIcon.vue?vue&type=template&id=21a241b0", function () {
      api.rerender('21a241b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/EditIcon.vue"
export default component.exports